import React from 'react'
import { useTranslation } from 'react-i18next'
import { AddressSwitcherProps } from '../../../../../../@types/props-types'

const AddressSwitcher: React.FC<AddressSwitcherProps> = ({ isNational, setIsNational }) => {
  const { t } = useTranslation()
  return (
    <div className='margin-bottom-l'>
      {isNational ? (
        <>
          <span className='margin-right-xs'>
            {t(
              'wizard.screen.internationalAddress.addressSwitchText',
              'Start with the location of your home and the four most important facts and figures.'
            )}
          </span>
          <button
            id='address-switcher-button'
            className='link-text padding-horizontal-none'
            onClick={() => setIsNational(false)}
          >
            {t('wizard.screen.internationalAddress.linkForNationalVariant', 'Your property is international?')}
          </button>
        </>
      ) : (
        <button
          id='address-switcher-button'
          className='link-text padding-horizontal-none'
          onClick={() => setIsNational(true)}
        >
          {t('wizard.screen.internationalAddress.linkForInternationalVariant', 'Your property is in germany?')}
        </button>
      )}
    </div>
  )
}

export default AddressSwitcher
